import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Parameter } from 'domain/entities/parameter';
import DropdownComponent from 'presentation/components/Shared/DropdownComponent';
import InputDateComponent from 'presentation/components/Shared/InputDateComponent';
import TimesheetReportUpload from 'presentation/components/Timesheet/TimesheetReportUpload';
import TripsheetReportDownloader from 'presentation/components/Tripsheet/TripsheetReportDownloader';


const reportParameterOptions: Parameter[] = [
    { id: 'timesheet', value: 'Mapa de Horas', type: 'report_type' },
    { id: 'tripsheet', value: 'Mapa de KM', type: 'report_type' }
];

const ExportForm: React.FC = () => {
    const [selectedReportType, setSelectedReportType] = useState<string>('');
    const [mesAno, setMesAno] = useState<Date | null>(null);
    const [reportRequest, setReportRequest] = useState<{ type: string, date: Date } | null>(null);
    const toast = useRef<Toast>(null);

    const handleMesAnoChange = (updatedObject: { mesAno: Date | null }) => {
        setMesAno(updatedObject.mesAno);
    };

    const handleReportTypeChange = (updatedObject: { reportType: string }) => {
        setSelectedReportType(updatedObject.reportType);
    };

    React.useEffect(() => {
        // Se ambos os campos estiverem preenchidos, aciona a renderização do componente filho
        if (mesAno && selectedReportType) {
            if (selectedReportType === 'Mapa de Horas') {
                setReportRequest({ type: 'Mapa de Horas', date: mesAno });
            } else if (selectedReportType === 'Mapa de KM') {
                setReportRequest({ type: 'Mapa de KM', date: mesAno });
            }
        } else {
            // Se algum campo for limpo, esconde o componente filho
            setReportRequest(null);
        }
    }, [mesAno, selectedReportType]);

    const renderContent = () => {
        if (reportRequest?.type === 'Mapa de Horas') {
            return <TimesheetReportUpload date={reportRequest.date} onComplete={() => { setReportRequest(null); setMesAno(null); }} />;
        }

        if (reportRequest?.type === 'Mapa de KM') {
            return <TripsheetReportDownloader date={reportRequest.date} onComplete={() => { setReportRequest(null); setMesAno(null); }} />;
        }

        return (
            <div className="text-center py-6">
                <i className="pi pi-file-pdf text-6xl text-gray-400 mb-3"></i>
                <h3 className="text-gray-600 mb-2">Nenhum relatório gerado</h3>
                <p className="text-gray-500">Utilize os filtros acima e clique em "Descarregar".</p>
            </div>
        );
    };

    const formDisabled = !!reportRequest;

    return (
        <div className="card">
            <Toast ref={toast} />
            <div className="formgrid grid p-fluid">
                <div className="field col-12 md:col-6">
                    <DropdownComponent
                        fieldName="reportType"
                        label="Tipo de Relatório"
                        options={reportParameterOptions}
                        currentObject={{ reportType: selectedReportType }}
                        getValue={selectedReportType}
                        setValue={handleReportTypeChange}
                        isDisable={formDisabled}
                    />
                </div>
                <div className="field col-12 md:col-6">
                    <InputDateComponent
                        fieldName="mesAno"
                        label="Mês de Referência"
                        currentObject={{ mesAno: mesAno }}
                        getValue={mesAno}
                        setValue={handleMesAnoChange}
                        view="month"
                        dateFormat="MM/yy"
                        isDisable={formDisabled}
                    />
                </div>
            </div>

            <Divider className="my-4" />

            <div className="mt-4">
                {renderContent()}
            </div>
        </div>
    );
};

export default ExportForm;